import Axios from 'axios'
import {
  API_ROOT
} from '../../config'

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000
});
console.log(API_ROOT);

export default {
  state: {
    loading: {
      personalia: true,
      verzuim: true,
      interesse: true,
      anderevaardigheden: true,
      gedrag: true,
      leerprestaties: true,
      socialemo: true,
      omgangleerkracht: true,
      contactouders: true,
      leerdeficientie: true,
      rapport: true,
      werkhouding: false,
      vervolgonderwijs: true
    }
  },
  mutations: {
    setLoading(state, obj) {
      console.log('Set loading ' + obj.name);
      state.loading[obj.name] = obj.value;
    },
    resetLoading(state) {
      state.loading.personalia = true;
      state.loading.verzuim = true;
      state.loading.interesse = true;
      state.loading.anderevaardigheden = true;
      state.loading.gedrag = true;
      state.loading.leerprestaties = true;
      state.loading.socialemo = true;
      state.loading.omgangleerkracht = true;
      state.loading.contactouders = true;
      state.loading.leerdeficientie = true;
      state.loading.rapport = true;
      state.loading.werkhouding = false;
      state.loading.vervolgonderwijs = true;
    }
  },
  getters: {
    getLoading(state) {
      return state.loading;
    }
  },
  actions: {
    load(context, obj) {
      context.commit('setLoading', obj);
    },
    resetloading(context, obj) {
      context.commit('resetLoading');
    }
  }
}
